export const snackMessages = {
  brand_description: "No brand found for this url.",
  general_info: "No business info found for this brand.",
  general_twitter_info: "No organic growth data found for this brand.",
  potential_users: "No potential users data found for this brand.",
  community_sentiment: "No user sentiment data found for this brand.",
  google_searches: "No google searches data found for this brand.",
  competitors: "No competitors data found for this brand.",
  organic_growth: 'No organic growth data found for this brand.',
}